import { Bound } from "lib/@components/binding/Bound"
import { BoundBlurChangeTextField } from "lib/@components/debounced-text-field/blur-change-text-field"
import { UOM_TO_NAME } from "routes/schedule/lib/uom-to-input"

export function ReadonlyUOM({ uom }) {
    return (
        <Bound readOnly={true}>
            <BoundBlurChangeTextField
                InputProps={{ readOnly: true }}
                key={uom}
                sx={{ mb: 1 }}
                transformIn={(v) => (+v === 0 ? 1 : v)}
                field={uom}
                label={UOM_TO_NAME[uom]}
                default={1}
                data-cy="read-only-no-of-assets"
            />
        </Bound>
    )
}
